import React from "react";
import { Layout, Typography, Divider } from "antd";

const { Footer } = Layout;
const { Text } = Typography;

const CashGoFooter: React.FC = () => {
  return (
    <Footer style={{ backgroundColor: "#fff", padding: "12px 24px", textAlign: "center" }}>
      <Divider style={{ marginBottom: 12, borderColor: "#004213" }} />
      <Text style={{ color: "#004213" }}>
        ©2025 – 42.544.764/0001-98 – ANTECIPA SOLUCOES FINANCEIRAS E TECNOLOGIA LTDA – Todos os direitos reservados
      </Text>
    </Footer>
  );
};

export default CashGoFooter;
